var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "splitter-container",
      class: { hide: _vm.hide },
      attrs: { id: _vm.data.sp_id }
    },
    [
      _c("splitter-title", {
        attrs: {
          splitter: _vm.data,
          title: _vm.data.sp_label,
          nivel: _vm.nivel
        },
        on: { "open-menu": _vm.openMenu }
      }),
      _vm._v(" "),
      !_vm.hide
        ? _c("div", { staticClass: "splitter-connections-container" }, [
            _c(
              "div",
              { staticClass: "connections-wrapper connections-wrapper-left" },
              _vm._l(_vm.data.inPorts, function(object, index) {
                return _c("Connection", {
                  key: index,
                  attrs: {
                    data: object,
                    side: "left",
                    list: _vm.list,
                    label: _vm.getObjectConnected(object),
                    "fiber-colors": _vm.fiberColors,
                    cables: _vm.cables,
                    splitters: _vm.splitters
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "centerLine",
                staticClass: "lines-wrapper",
                style: { width: "195px" }
              },
              [
                _c("img", {
                  staticClass: "lines-container-img",
                  attrs: { src: require("@/assets/splitterConnection.png") }
                }),
                _vm._v(" "),
                _c(
                  "svg",
                  { staticClass: "lines-container" },
                  _vm._l(_vm.points, function(point, index) {
                    return _c("line", {
                      key: index,
                      staticClass: "connection-line",
                      attrs: {
                        x1: point.x1,
                        y1: point.y1,
                        x2: point.x2,
                        y2: point.y2,
                        "stroke-dasharray": "5 4"
                      }
                    })
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "connections-wrapper connections-wrapper-right" },
              _vm._l(_vm.data.outPorts, function(object, index) {
                return _c("Connection", {
                  key: index,
                  attrs: {
                    data: object,
                    side: "right",
                    list: _vm.list,
                    label: _vm.getObjectConnected(object),
                    "fiber-colors": _vm.fiberColors,
                    cables: _vm.cables,
                    splitters: _vm.splitters
                  }
                })
              }),
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2316faa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2316faa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/Splitter.vue
// module id = null
// module chunks = 